import * as React from "react";
import { findDOMNode } from "react-dom";
/**
 * Snap in replacement for the react-virtualized CellMeasurer component.
 */
export class DataGridCellMeasurer extends React.PureComponent {
  constructor(props) {
    super(props);
  }
  render() {
    return this.props.children;
  }
  componentDidMount() {
    this._maybeMeasureCell();
  }
  componentDidUpdate() {
    this._maybeMeasureCell();
  }

  /**
   * Called to determine the actual width/height needed to render the cell.
   * This will be called from componentDidUpdate() and the width/height will be set to "auto".
   * Once we determine the actual width/height we return it and it gets placed into the CellMeasurerCache
   * until that cache gets invalidated.
   * PJM: Note that I have commented out most of the code that WAS in the CellMeasurer implementation that
   * caused layout thrashing. I did not see any negative effects of doing this, but if anyone
   * sees any problems, we can revisit.
   * @returns {any}
   * @private
   */
  _getCellMeasurements() {
    const node = findDOMNode(this);

    // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height

    /* eslint-disable abinitio/no-instanceof */
    if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
      // Note that code here started as a copy of the react-virtualized CellMeasurer.js implementation
      // which has serious layout thrashing. Basically, I commented out places where it did DOM read/write pairs
      // and reduced it to simply querying for the offsetHeight after being rendered into the DOM
      let cache = this.props.cache;
      const badHeight = node.style.height !== "auto";
      const badWidth = node.style.width !== "auto";
      // PJM: Hack 1: Do we need to restore width/height?
      const styleWidth = node.style.width;
      const styleHeight = node.style.height;

      // If we are re-measuring a cell that has already been measured,
      // It will have a hard-coded width/height from the previous measurement.
      // The fact that we are measuring indicates this measurement is probably stale,
      // So explicitly clear it out (eg set to "auto") so we can recalculate.
      // See issue #593 for more info.
      // Even if we are measuring initially- if we're inside of a MultiGrid component,
      // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
      // eg top/left Grid renders before bottom/right Grid
      // Since the CellMeasurerCache is shared between them this taints derived cell size values.

      // PJM: I didn't see any warnings here. But who knows???
      // if (node.style.height !== "auto")
      // {
      //   console.warn(`DataGridCellMeasurer._getCellMeasurements [${this.props.rowIndex}, ${this.props.columnIndex}]  height = ${node.style.height} `);
      // }
      // else
      // {
      //   console.info(`DataGridCellMeasurer._getCellMeasurements [${this.props.rowIndex}, ${this.props.columnIndex}]`);
      // }

      if (!cache.hasFixedWidth() && badWidth) {
        node.style.width = "auto";
      }
      if (!cache.hasFixedHeight() && badHeight) {
        node.style.height = "auto";
      }
      const height = Math.ceil(node.offsetHeight);
      const width = Math.ceil(node.offsetWidth);

      // Reset after measuring to avoid breaking styles; see #660
      // PJM: Is this necessary?
      if (styleWidth && badWidth) {
        node.style.width = styleWidth;
      }
      if (styleHeight && badHeight) {
        node.style.height = styleHeight;
      }
      return {
        height,
        width
      };
    } else {
      return {
        height: 0,
        width: 0
      };
    }
  }
  _maybeMeasureCell() {
    const {
      cache,
      columnIndex = 0,
      parent,
      rowIndex = this.props.index || 0
    } = this.props;

    // See if the cell has been measured recently.  If not, we will re-measure it
    this._checkCellFreshness(rowIndex, columnIndex, cache);
    if (!cache.has(rowIndex, columnIndex)) {
      const {
        height,
        width
      } = this._getCellMeasurements();
      cache.set(rowIndex, columnIndex, width, height);
      this._markCellFresh(rowIndex, columnIndex);

      // If size has changed, let Grid know to re-render
      if (parent && parent.invalidateCellSizeAfterRender) {
        parent.invalidateCellSizeAfterRender({
          columnIndex,
          rowIndex
        });
      }
    }
  }

  /**
   * Determine if we have recently measured the size of a cell.  If not, remove the measurement from the cache
   * so that it will be recomputed
   * @param rowIndex
   * @param columnIndex
   * @param cache
   * @private
   */
  _checkCellFreshness(rowIndex, columnIndex, cache) {
    const {
      cellMeasurementFreshness
    } = this.props;
    if (cellMeasurementFreshness && !cellMeasurementFreshness.isFresh(rowIndex, columnIndex)) {
      cache.clear(rowIndex, columnIndex);
    }
  }

  /**
   * Mark a cell as having been recently measured
   * @param rowIndex
   * @param columnIndex
   * @private
   */
  _markCellFresh(rowIndex, columnIndex) {
    const {
      cellMeasurementFreshness
    } = this.props;
    cellMeasurementFreshness && cellMeasurementFreshness.markFresh(rowIndex, columnIndex);
  }
}
//# sourceMappingURL=DataGridCellMeasurer.js.map
